import { NgModule } from '@angular/core';
import { ModalModule, TypeaheadModule, TabsModule, AccordionModule, PaginationModule, BsDatepickerModule, BsDropdownModule  } from 'ngx-bootstrap';

const ngxModules = [
  ModalModule.forRoot(),
  TypeaheadModule.forRoot(),
  TabsModule.forRoot(),
  PaginationModule .forRoot(),
  BsDatepickerModule.forRoot(),
  AccordionModule.forRoot(),
  BsDropdownModule.forRoot()
]

@NgModule({
  imports: [
    ngxModules
  ],
  declarations: [],
  exports:[ModalModule, AccordionModule, TypeaheadModule, TabsModule, PaginationModule, BsDatepickerModule, BsDropdownModule]
})
export class NgxBootstrapModule { }



// WEBPACK FOOTER //
// ./src/app/ngx-bootstrap.module.ts